import { gql } from "@apollo/client";

export const GET_SUTDENT_AND_ATTENDANCE_RATE_REPORT = gql`
query GetStudentAndAttendanceRateReport($academicYearId: ID, $schoolId: ID) {
  getStudentAndAttendanceRateReport(academic_year_id: $academicYearId, school_id: $schoolId) {
    detail_data {
      level_name
      student_and_attendance_rate_by_group {
        group_name
        dream_class_registration {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        dream_student_q2 {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        drop_out_q2 {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        dream_student_q3 {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        drop_out_q3 {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        dream_student_q4 {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        drop_out_q4 {
          total
          male
          female
          male_as_percentage
          female_as_percentage
        }
        q2_attendance_rate
        q3_attendance_rate
        q4_attendance_rate
        yearly_attendance_rate
      }
      dream_class_registration {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      dream_student_q2 {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      drop_out_q2 {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      dream_student_q3 {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      drop_out_q3 {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      dream_student_q4 {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      drop_out_q4 {
        total
        male
        female
        male_as_percentage
        female_as_percentage
      }
      q2_attendance_rate
      q3_attendance_rate
      q4_attendance_rate
      yearly_attendance_rate
    }
    dream_class_registration {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    dream_student_q2 {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    drop_out_q2 {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    dream_student_q3 {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    drop_out_q3 {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    dream_student_q4 {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    drop_out_q4 {
      total
      male
      female
      male_as_percentage
      female_as_percentage
    }
    q2_attendance_rate
    q3_attendance_rate
    q4_attendance_rate
    yearly_attendance_rate
  }
}
`